export default {
  CORE: 'CORE',
  SHARED: 'SHARED',
  APP: 'APP',
  DASHBOARD: 'DASHBOARD',
};
